import React from "react";
import { StaticImage } from "gatsby-plugin-image";

function footer() {
	return (
		<div id="footer">
			<div className="footer_container">
				<div className="footer_wrapper">
					<h2>Let's connect</h2>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Capa_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							width="20px"
							height="20px"
							viewBox="0 0 891.024 891.024"
							xmlSpace="preserve"
						>
							<g>
								<path
									d="M2.8,180.875c46.6,134,144.7,286.2,282.9,424.399c138.2,138.2,290.4,236.301,424.4,282.9c18.2,6.3,38.3,1.8,52-11.8
		l92.7-92.7l21.6-21.6c19.5-19.5,19.5-51.2,0-70.7l-143.5-143.4c-19.5-19.5-51.2-19.5-70.7,0l-38.899,38.9
		c-20.2,20.2-52.4,22.2-75,4.6c-44.7-34.8-89-73.899-131.9-116.8c-42.9-42.9-82-87.2-116.8-131.9c-17.601-22.6-15.601-54.7,4.6-75
		l38.9-38.9c19.5-19.5,19.5-51.2,0-70.7l-143.5-143.5c-19.5-19.5-51.2-19.5-70.7,0l-21.6,21.6l-92.7,92.7
		C1,142.575-3.5,162.675,2.8,180.875z"
								/>
							</g>
						</svg>
						<div className="footer_items">
							<h3>0728821120</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Capa_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							width="20px"
							height="20px"
							viewBox="0 0 891.024 891.024"
							xmlSpace="preserve"
						>
							<g>
								<path
									d="M2.8,180.875c46.6,134,144.7,286.2,282.9,424.399c138.2,138.2,290.4,236.301,424.4,282.9c18.2,6.3,38.3,1.8,52-11.8
		l92.7-92.7l21.6-21.6c19.5-19.5,19.5-51.2,0-70.7l-143.5-143.4c-19.5-19.5-51.2-19.5-70.7,0l-38.899,38.9
		c-20.2,20.2-52.4,22.2-75,4.6c-44.7-34.8-89-73.899-131.9-116.8c-42.9-42.9-82-87.2-116.8-131.9c-17.601-22.6-15.601-54.7,4.6-75
		l38.9-38.9c19.5-19.5,19.5-51.2,0-70.7l-143.5-143.5c-19.5-19.5-51.2-19.5-70.7,0l-21.6,21.6l-92.7,92.7
		C1,142.575-3.5,162.675,2.8,180.875z"
								/>
							</g>
						</svg>
						<div className="footer_items">
							<h3>0110436294</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							height="20px"
							width="20px"
							viewBox="0 0 330.001 330.001"
							xmlSpace="preserve"
						>
							<g id="XMLID_348_">
								<path
									id="XMLID_350_"
									d="M173.871,177.097c-2.641,1.936-5.756,2.903-8.87,2.903c-3.116,0-6.23-0.967-8.871-2.903L30,84.602
		L0.001,62.603L0,275.001c0.001,8.284,6.716,15,15,15L315.001,290c8.285,0,15-6.716,15-14.999V62.602l-30.001,22L173.871,177.097z"
								/>
								<polygon
									id="XMLID_351_"
									points="165.001,146.4 310.087,40.001 19.911,40 	"
								/>
							</g>
						</svg>
						<div className="footer_items">
							<h3>victorboninteriors@gmail.com</h3>
						</div>
					</div>
				</div>
				<div className="footer_wrapper">
					<h2>Our services</h2>
					<div className="footer_item">
						<svg
							width="20px"
							height="20px"
							viewBox="0 -64 640 640"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z" />
						</svg>
						<div className="footer_items">
							<h3>Decoration</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Capa_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 444.892 444.892"
							xmlSpace="preserve"
							width="20px"
							height="20px"
						>
							<g id="XMLID_476_">
								<path
									id="XMLID_503_"
									d="M440.498,173.103c5.858-5.857,5.858-15.355,0-21.213l-22.511-22.511c-5.091-5.091-13.084-5.846-19.038-1.8
		l-47.332,32.17l31.975-47.652c3.993-5.951,3.219-13.897-1.85-18.964l-48.83-48.83c-4.508-4.508-11.372-5.675-17.114-2.908
		l-8.443,4.065l4.043-8.97c2.563-5.685,1.341-12.361-3.068-16.771L293.002,4.393c-5.857-5.857-15.355-5.857-21.213,0
		l-119.06,119.059l168.71,168.71L440.498,173.103z"
								/>
								<path
									id="XMLID_1199_"
									d="M130.56,145.622l-34.466,34.466c-2.813,2.813-4.394,6.628-4.394,10.606s1.58,7.794,4.394,10.606
		l32.694,32.694c6.299,6.299,9.354,14.992,8.382,23.849c-0.971,8.851-5.843,16.677-13.366,21.473
		C27.736,340.554,18.781,349.51,15.839,352.453c-21.119,21.118-21.119,55.48,0,76.6c21.14,21.14,55.504,21.098,76.6,0
		c2.944-2.943,11.902-11.902,73.136-107.965c4.784-7.505,12.607-12.366,21.462-13.339c8.883-0.969,17.575,2.071,23.859,8.354
		l32.694,32.694c5.857,5.857,15.356,5.857,21.213,0l34.467-34.467L130.56,145.622z M70.05,404.825c-8.28,8.28-21.704,8.28-29.983,0
		c-8.28-8.28-8.28-21.704,0-29.983c8.28-8.28,21.704-8.28,29.983,0C78.33,383.121,78.33,396.545,70.05,404.825z"
								/>
							</g>
						</svg>
						<div className="footer_items">
							<h3>Paints</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Capa_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 436.519 436.52"
							xmlSpace="preserve"
							width="20px"
							height="20px"
						>
							<g>
								<g>
									<path
										d="M428.956,160.938l-49.833-37.16c-1.905-2.289-4.32-4.095-7.065-5.268L220.289,5.354c-0.451-0.328-0.903-0.611-1.081-0.698
			c-0.574-0.373-1.165-0.722-1.709-0.99c-0.473-0.231-0.945-0.435-1.74-0.743c-0.583-0.225-1.173-0.425-1.656-0.553
			c-0.574-0.16-1.149-0.273-1.698-0.365c-0.614-0.113-1.226-0.205-2.011-0.263c-0.338-0.024-0.671-0.035-1.01-0.035l-0.672,0.011
			c-0.63,0.01-1.27,0.045-1.774,0.107c-0.543,0.066-1.076,0.164-1.683,0.292c-0.656,0.134-1.323,0.301-1.953,0.504
			c-0.482,0.157-0.955,0.346-1.643,0.64c-0.56,0.242-1.113,0.496-1.678,0.809c-0.527,0.289-1.031,0.622-1.317,0.832l-0.903,0.575
			l-43.138,35.258c-2.075-8.134-9.462-14.171-18.233-14.171H93.434c-10.373,0-18.814,8.441-18.814,18.813v60.743L6.913,161.456
			c-3.893,3.176-6.312,7.688-6.816,12.685c-0.506,5,0.974,9.896,4.145,13.778c3.585,4.396,8.895,6.918,14.577,6.918
			c4.329,0,8.552-1.512,11.9-4.247l18.691-15.27v161.731c0,10.372,8.441,18.814,18.813,18.814c10.376,0,18.814-8.442,18.814-18.814
			V144.566L209.65,44.357l136.185,101.542v191.151c0,10.372,8.442,18.814,18.814,18.814c10.378,0,18.814-8.442,18.814-18.814
			V173.952l23.013,17.16c3.276,2.441,7.161,3.725,11.233,3.725c5.927,0,11.56-2.832,15.093-7.57
			C438.993,178.952,437.276,167.144,428.956,160.938z M424.179,180.845c-1.581,2.123-4.012,3.246-6.469,3.246
			c-1.675,0-3.363-0.522-4.812-1.596l-40.189-29.963v184.519c0,4.451-3.612,8.063-8.063,8.063s-8.063-3.612-8.063-8.063V140.503
			L209.344,30.719L76.287,139.464v197.587c0,4.451-3.612,8.063-8.063,8.063s-8.063-3.612-8.063-8.063V152.645l-36.239,29.621
			c-1.496,1.225-3.302,1.815-5.098,1.815c-2.338,0-4.654-1.01-6.247-2.963c-2.816-3.448-2.309-8.524,1.142-11.346l71.657-58.571
			V45.373c0-4.457,3.614-8.063,8.063-8.063h42.956c4.452,0,8.063,3.606,8.063,8.063v17.551l59.56-48.68
			c0.16-0.129,0.338-0.22,0.509-0.338c0.226-0.156,0.447-0.323,0.683-0.452c0.25-0.134,0.507-0.242,0.764-0.35
			c0.221-0.091,0.436-0.193,0.662-0.268c0.275-0.092,0.559-0.146,0.834-0.204c0.226-0.048,0.452-0.103,0.683-0.129
			c0.273-0.034,0.554-0.039,0.822-0.044c0.247-0.005,0.488-0.01,0.738,0c0.262,0.021,0.524,0.071,0.784,0.113
			c0.247,0.044,0.494,0.082,0.74,0.146c0.271,0.069,0.527,0.177,0.785,0.273c0.221,0.092,0.446,0.168,0.667,0.275
			c0.281,0.135,0.538,0.305,0.795,0.473c0.147,0.097,0.308,0.166,0.452,0.273l152.932,114.027c1.916,0.554,3.532,1.77,4.583,3.415
			l51.087,38.09C426.106,172.223,426.839,177.27,424.179,180.845z"
									/>
									<path d="M101.497,98.03l26.83-21.93v-22.67h-26.83V98.03z" />
									<path
										d="M192.241,285.606c-0.118,0.064-0.221,0.158-0.338,0.221c0.068,0.116,0.094,0.257,0.16,0.378
			c0.267,0.494,0.488,1.008,0.661,1.554c0.077,0.221,0.145,0.426,0.205,0.646c0.186,0.75,0.317,1.521,0.317,2.324v14.216
			c0,0.725-0.097,1.418-0.244,2.09c-0.052,0.221-0.134,0.421-0.196,0.635c-0.129,0.446-0.281,0.893-0.476,1.313
			c-0.036,0.067-0.047,0.156-0.084,0.226c0.037,0.073,0.048,0.156,0.084,0.226c0.195,0.419,0.339,0.86,0.476,1.312
			c0.062,0.216,0.144,0.421,0.196,0.637c0.147,0.676,0.244,1.369,0.244,2.088v14.216c0,0.725-0.097,1.417-0.244,2.088
			c-0.052,0.233-0.139,0.446-0.207,0.673c-0.126,0.431-0.265,0.856-0.452,1.249c-0.039,0.085-0.055,0.174-0.092,0.252
			c0.037,0.08,0.053,0.168,0.092,0.252c0.182,0.399,0.321,0.82,0.452,1.251c0.068,0.219,0.155,0.435,0.207,0.671
			c0.147,0.672,0.244,1.365,0.244,2.09v14.21c0,0.709-0.097,1.4-0.244,2.083c-0.047,0.211-0.124,0.405-0.186,0.615
			c-0.128,0.446-0.281,0.892-0.473,1.317c-0.039,0.083-0.055,0.174-0.092,0.252c0.042,0.083,0.058,0.179,0.097,0.262
			c0.182,0.395,0.315,0.809,0.441,1.233c0.067,0.231,0.16,0.447,0.212,0.684c0.147,0.672,0.244,1.365,0.244,2.085v14.213
			c0,5.324-4.328,9.64-9.638,9.64h-14.546l-0.005,12.156c0,10.126,8.239,18.373,18.374,18.373c10.131,0,18.378-8.247,18.378-18.373
			V274.541l-11.725,9.901C193.52,284.915,192.89,285.292,192.241,285.606z M195.057,394.946c0,4.205-3.425,7.622-7.627,7.622
			c-4.205,0-7.622-3.417-7.622-7.616v-1.407h3.8c4.239,0,8.182-1.302,11.449-3.527V394.946z"
									/>
									<polygon points="182.496,360.055 163.246,360.055 144.264,360.06 144.264,372.044 163.687,372.044 182.496,372.044 		" />
									<path
										d="M211.892,241.344c-0.774,0.216-1.354,0.2-2.052,0.021l-29.581,24.987l7.736,9.154l19.404-16.399
			c2-1.679,4.918-1.689,6.918-0.011l6.598,5.56c1.213,1.023,1.906,2.524,1.906,4.111v103.276h19.124V267.916
			c-0.111-0.483-0.133-0.86-0.102-1.271L211.892,241.344z"
									/>
									<path
										d="M275.069,270.342h-11.612v-2.426c0-0.352-0.016-0.702-0.031-1.055c0.199-6.21-2.452-12.216-7.207-16.226l-30.935-26.122
			c-3.303-2.781-7.714-4.451-12.224-4.667l-0.352-0.099h-8.434v-73.746c4.859-2.785,8.145-8.022,8.145-14.009v-31.57
			c0-8.892-7.236-16.125-16.126-16.125h-16.289c-8.89,0-16.126,7.233-16.126,16.125v31.57c0,5.992,3.286,11.229,8.149,14.009v73.735
			h-8.335c-8.893,0-16.126,7.238-16.126,16.127l-0.005,34.467h-4.425c-11.224,0.021-20.352,9.177-20.352,20.389v14.221
			c0,1.443,0.152,2.866,0.464,4.264c-0.312,1.4-0.464,2.817-0.464,4.262v14.21c0,1.443,0.152,2.867,0.464,4.262
			c-0.312,1.402-0.464,2.825-0.464,4.264v14.216c0,1.437,0.157,2.859,0.464,4.257c-0.312,1.401-0.47,2.819-0.475,4.267v14.216
			c0,11.239,9.149,20.378,20.394,20.378h4.394v1.402c0,21.985,17.888,39.875,39.88,39.875c21.984,0,39.875-17.89,39.875-39.875
			v-1.402h15.758c2.872,0,5.654-0.593,8.186-1.706c2.529,1.113,5.306,1.706,8.183,1.706h15.634c5.459,0,10.582-2.125,14.426-5.979
			c3.852-3.858,5.963-8.98,5.952-14.41l0.005-82.426c0-5.428-2.116-10.541-5.963-14.409
			C285.636,272.468,280.518,270.342,275.069,270.342z M284.696,373.156c0.006,2.562-0.991,4.988-2.808,6.809
			c-1.817,1.821-4.237,2.83-6.819,2.83h-15.633c-3.475,0-6.487-1.858-8.184-4.619c-1.695,2.761-4.72,4.619-8.189,4.619h-21.339
			c-1.902,0-3.672-0.573-5.166-1.528v13.675c0,16.064-13.068,29.124-29.124,29.124h-0.005c-16.058,0-29.124-13.07-29.124-29.124
			l0.005-12.146h-15.15c-5.315,0-9.643-4.326-9.643-9.639v-14.211c0.005-1.537,0.409-2.971,1.049-4.262
			c-0.64-1.285-1.039-2.724-1.039-4.262v-14.21c0-1.538,0.394-2.971,1.039-4.264c-0.646-1.291-1.039-2.729-1.039-4.262v-14.216
			c0-1.537,0.394-2.971,1.039-4.262c-0.646-1.293-1.039-2.725-1.039-4.264v-14.216c0-5.301,4.317-9.627,9.622-9.637h15.155
			l0.005-45.218c0-2.972,2.406-5.376,5.375-5.376h19.087v-93.13h-2.774c-2.971,0-5.375-2.409-5.375-5.375v-31.57
			c0-2.968,2.403-5.375,5.375-5.375h16.289c2.971,0,5.375,2.407,5.375,5.375v31.57c0,2.966-2.404,5.375-5.375,5.375h-2.769v93.13
			h15.905c0.042,0,0.097,0,0.144,0c0.045,0,0.092,0,0.143,0h1.462c0.144,0,0.273,0.073,0.417,0.083
			c2.265-0.104,4.903,0.59,6.77,2.153l30.919,26.109c2.377,2.007,3.616,5.046,3.369,8.115c0.033,0.321,0.049,0.642,0.049,0.956
			v15.932c1.811-1.773,4.179-2.755,6.713-2.755h15.654c2.577,0,4.997,1.007,6.819,2.83c1.815,1.82,2.812,4.241,2.812,6.807V373.156z
			"
									/>
									<rect x="260.56" y="291.844" width="13.391" height="80.2" />
									<polygon points="182.496,349.303 182.496,337.313 163.432,337.323 144.274,337.323 144.274,349.309 163.519,349.303 		" />
									<polygon points="182.496,291.844 163.681,291.844 144.274,291.844 144.274,303.828 182.496,303.828 		" />
									<path
										d="M172.479,258.85l20.835-17.6h-24.258l-0.005,24.798c0.005-0.21,0.016-0.42,0.037-0.63
			C169.309,262.846,170.508,260.515,172.479,258.85z"
									/>
									<path
										d="M171.335,272.437c-0.651-0.771-1.128-1.644-1.505-2.558c-0.065-0.146-0.136-0.288-0.193-0.439
			c-0.313-0.872-0.478-1.797-0.527-2.729c-0.005-0.101-0.053-0.189-0.053-0.29v14.673h9.588L171.335,272.437z"
									/>
									<polygon points="182.496,326.562 182.496,314.579 144.274,314.579 144.274,326.574 163.432,326.574 		" />
									<rect x="185.375" y="105.804" width="40px" height="40px" />
								</g>
							</g>
						</svg>
						<div className="footer_items">
							<h3>Gypsum/ceiling</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							width="20px"
							height="20px"
							viewBox="0 0 503.608 503.608"
							xmlSpace="preserve"
						>
							<g>
								<g>
									<g>
										<path
											d="M452.131,56.147c-46.651-11.642-114.763-13.564-161.951-4.6l-6.891,1.326c-10.995,2.107-22.36,4.289-33.532,6.01
				l-6.345,0.982v157.713l31.576,4.851c15.922,3.895,35.286,6.421,55.825,7.655l13.513,61.532c0.848,3.844,4.255,6.589,8.2,6.589
				h16.787v50.361h92.319l-0.017-59.308l-4.625-69.422c27.724-9.459,46.617-35.118,46.617-64.319v-33.574
				C503.608,90.77,482.44,63.718,452.131,56.147z M369.313,281.419h-10.039l-11.096-50.52c1.981,0.05,3.987-0.008,5.976,0.017
				c1.981,0.025,3.953,0.067,5.934,0.067c1.259,0,2.518-0.034,3.769-0.042c1.821-0.017,3.626,0.042,5.456,0.008V281.419z
				 M436.461,147.124H386.1c-4.633,0-8.393-3.752-8.393-8.393c0-4.642,3.76-8.393,8.393-8.393h50.361
				c4.633,0,8.393,3.752,8.393,8.393C444.854,143.372,441.094,147.124,436.461,147.124z M436.461,113.55H386.1
				c-4.633,0-8.393-3.752-8.393-8.393c0-4.642,3.76-8.393,8.393-8.393h50.361c4.633,0,8.393,3.752,8.393,8.393
				C444.854,109.798,441.094,113.55,436.461,113.55z"
										/>
										<path
											d="M160.508,96.763h-34.606c-18.516,0-33.574,15.058-33.574,33.574H8.393C3.76,130.337,0,134.089,0,138.73
				c0,4.642,3.76,8.393,8.393,8.393h83.934c0,18.516,15.058,33.574,33.574,33.574h34.606c3.341,14.865,15.284,26.498,30.963,28.907
				l35.152,5.397V62.442l-35.152,5.414C175.792,70.265,163.848,81.898,160.508,96.763z M159.475,163.911h-33.574
				c-9.258,0-16.787-7.529-16.787-16.787v-16.787c0-9.258,7.529-16.787,16.787-16.787h33.574V163.911z"
										/>
										<polygon points="357.442,365.353 323.869,398.927 476.084,398.927 464.895,365.353 			" />
										<path
											d="M318.951,440.894c0,9.258,7.529,16.787,16.787,16.787h125.902c9.258,0,16.787-7.529,16.787-16.787v-25.18H318.951
				V440.894z"
										/>
									</g>
								</g>
							</g>
						</svg>
						<div className="footer_items">
							<h3>Fitting</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 512 512"
							xmlSpace="preserve"
							width="20px"
							height="20px"
						>
							<g>
								<g>
									<path
										d="M495.304,0H16.696C7.475,0,0,7.475,0,16.696v478.609C0,504.525,7.475,512,16.696,512h478.609
			c9.22,0,16.696-7.475,16.696-16.696V16.696C512,7.475,504.525,0,495.304,0z M478.609,478.609H33.391V33.391h445.217V478.609z"
									/>
								</g>
							</g>
							<g>
								<g>
									<path
										d="M428.522,66.783H83.478c-9.22,0-16.696,7.475-16.696,16.696v345.043c0,9.22,7.475,16.696,16.696,16.696h345.043
			c9.22,0,16.696-7.475,16.696-16.696V83.478C445.217,74.258,437.742,66.783,428.522,66.783z M178.087,317.217v94.609h-77.913
			V211.478h77.913V317.217z M100.174,178.087v-77.913h200.348v77.913H194.783H100.174z M300.522,211.478v89.043h-89.043v-89.043
			H300.522z M411.826,411.826H211.478v-77.913h105.739h94.609V411.826z M411.826,300.522h-77.913V194.783v-94.609h77.913V300.522z"
									/>
								</g>
							</g>
						</svg>
						<div className="footer_items">
							<h3>Floor and Tiles</h3>
						</div>
					</div>
				</div>
				<div className="footer_wrapper">
					<h2>Social Platforms</h2>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							width="20px"
							height="20px"
							viewBox="0 0 169.063 169.063"
							xmlSpace="preserve"
						>
							<g>
								<path
									d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
		c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
		c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
		c17.455,0,31.656,14.201,31.656,31.655V122.407z"
								/>
								<path
									d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
		C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
		c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
								/>
								<path
									d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
		c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
		C135.661,29.421,132.821,28.251,129.921,28.251z"
								/>
							</g>
						</svg>

						<div className="footer_items">
							<h3>Instagram</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Capa_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 290 290"
							xmlSpace="preserve"
							height="20px"
							width="20px"
						>
							<path
								d="M205.807,0h-15.694c-43.62,0-79.107,35.488-79.107,79.108v33.386H84.193c-2.761,0-5,2.239-5,5v40c0,2.761,2.239,5,5,5
	h26.811V285c0,2.761,2.239,5,5,5h40c2.761,0,5-2.239,5-5V162.494h39.786c2.761,0,5-2.239,5-5v-40c0-2.761-2.239-5-5-5h-39.786
	V79.108c0-16.05,13.058-29.108,29.107-29.108h15.694c2.761,0,5-2.239,5-5V5C210.807,2.239,208.568,0,205.807,0z"
							/>
						</svg>

						<div className="footer_items">
							<h3>facebook</h3>
						</div>
					</div>
					<div className="footer_item">
						<svg
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlnsXlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 310 310"
							xmlSpace="preserve"
							width="20px"
							height="20px"
						>
							<g id="XMLID_822_">
								<path
									id="XMLID_823_"
									d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938
		C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527
		C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991
		c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764
		c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861
		C204.394,157.263,202.325,160.684,199.021,162.41z"
								/>
							</g>
						</svg>

						<div className="footer_items">
							<h3>youtube</h3>
						</div>
					</div>
				</div>
				<div className="footer_wrapper">
					<h2>Gallery</h2>
					<div className="gallery_container">
						<div className="img_wrapper">
							<StaticImage
								className="slider_item_image"
								src="../images/gallery/pexels-vecislavas-popa-1571452.jpg"
								alt="project one"
								height={150}
								width={150}
							/>
						</div>
						<div className="img_wrapper">
							<StaticImage
								className="slider_item_image"
								src="../images/gallery/pexels-terje-sollie-312029.jpg"
								alt="project one"
								height={150}
								width={150}
							/>
						</div>
						<div className="img_wrapper">
							<StaticImage
								className="slider_item_image"
								src="../images/gallery/pexels-pixabay-271805.jpg"
								alt="project one"
								height={150}
								width={150}
							/>
						</div>
						<div className="img_wrapper">
							<StaticImage
								className="slider_item_image"
								src="../images/gallery/pexels-vecislavas-popa-1571468.jpg"
								alt="project one"
								height={150}
								width={150}
							/>
						</div>
						<div className="img_wrapper">
							<StaticImage
								className="slider_item_image"
								src="../images/gallery/pexels-pixabay-262048.jpg"
								alt="project one"
								height={150}
								width={150}
							/>
						</div>
						<div className="img_wrapper">
							<StaticImage
								className="slider_item_image"
								src="../images/gallery/pexels-pixabay-259962.jpg"
								alt="project one"
								height={150}
								width={150}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="footer_note">
				<div className="wrapper">
					<div className="logo-footer">
						<StaticImage
							className="logo-footer"
							src="../images/logo.png"
							alt="logo"
							height={50}
							width={135}
						/>
					</div>
					<div className="copyright">
						<p>copyright@2022</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default footer;
